import { JSONLD } from 'lincd-jsonld/utils/JSONLD';
import { createNameSpace } from 'lincd/utils/NameSpace';
import { linkedOntology } from '../package.js';
import * as _this from './dcterms.js';
export var loadData = () => {
    if (typeof module !== 'undefined' && typeof exports !== 'undefined') {
        // CommonJS import
        return import('../data/dcterms.json').then((data) => JSONLD.parse(data));
    }
    else {
        // ESM import
        //@ts-ignore
        return import('../data/dcterms.json', { with: { type: 'json' } }).then((data) => JSONLD.parse(data.default));
    }
};
export var ns = createNameSpace('http://purl.org/dc/terms/');
export var _self = ns('');
// Classes
export var AgentClass = ns('AgentClass');
export var Agent = ns('Agent');
export var BibliographicResource = ns('BibliographicResource');
export var FileFormat = ns('FileFormat');
export var Frequency = ns('Frequency');
export var Jurisdiction = ns('Jurisdiction');
export var LicenseDocument = ns('LicenseDocument');
export var LinguisticSystem = ns('LinguisticSystem');
export var Location = ns('Location');
export var LocationPeriodOrJurisdiction = ns('LocationPeriodOrJurisdiction');
export var MediaType = ns('MediaType');
export var MediaTypeOrExtent = ns('MediaTypeOrExtent');
export var MethodOfAccrual = ns('MethodOfAccrual');
export var MethodOfInstruction = ns('MethodOfInstruction');
export var PeriodOfTime = ns('PeriodOfTime');
export var PhysicalMedium = ns('PhysicalMedium');
export var PhysicalResource = ns('PhysicalResource');
export var Policy = ns('Policy');
export var ProvenanceStatement = ns('ProvenanceStatement');
export var RightsStatement = ns('RightsStatement');
export var SizeOrDuration = ns('SizeOrDuration');
export var Standard = ns('Standard');
// Properties
export var abstract = ns('abstract');
export var accessRights = ns('accessRights');
export var accrualMethod = ns('accrualMethod');
export var accrualPeriodicity = ns('accrualPeriodicity');
export var accrualPolicy = ns('accrualPolicy');
export var alternative = ns('alternative');
export var audience = ns('audience');
export var available = ns('available');
export var bibliographicCitation = ns('bibliographicCitation');
export var conformsTo = ns('conformsTo');
export var contributor = ns('contributor');
export var coverage = ns('coverage');
export var created = ns('created');
export var creator = ns('creator');
export var date = ns('date');
export var dateAccepted = ns('dateAccepted');
export var dateCopyrighted = ns('dateCopyrighted');
export var dateSubmitted = ns('dateSubmitted');
export var description = ns('description');
export var educationLevel = ns('educationLevel');
export var extent = ns('extent');
export var format = ns('format');
export var hasFormat = ns('hasFormat');
export var hasPart = ns('hasPart');
export var hasVersion = ns('hasVersion');
export var identifier = ns('identifier');
export var instructionalMethod = ns('instructionalMethod');
export var isFormatOf = ns('isFormatOf');
export var isPartOf = ns('isPartOf');
export var isReferencedBy = ns('isReferencedBy');
export var isReplacedBy = ns('isReplacedBy');
export var isRequiredBy = ns('isRequiredBy');
export var issued = ns('issued');
export var isVersionOf = ns('isVersionOf');
export var language = ns('language');
export var license = ns('license');
export var mediator = ns('mediator');
export var medium = ns('medium');
export var modified = ns('modified');
export var provenance = ns('provenance');
export var publisher = ns('publisher');
export var references = ns('references');
export var relation = ns('relation');
export var replaces = ns('replaces');
export var requires = ns('requires');
export var rights = ns('rights');
export var rightsHolder = ns('rightsHolder');
export var source = ns('source');
export var spatial = ns('spatial');
export var subject = ns('subject');
export var tableOfContents = ns('tableOfContents');
export var temporal = ns('temporal');
export var title = ns('title');
export var type = ns('type');
export var valid = ns('valid');
export var Image = ns('Image');
export const dcterms = {
    abstract,
    accessRights,
    accrualMethod,
    accrualPeriodicity,
    accrualPolicy,
    alternative,
    audience,
    available,
    bibliographicCitation,
    conformsTo,
    contributor,
    coverage,
    created,
    creator,
    date,
    dateAccepted,
    dateCopyrighted,
    dateSubmitted,
    description,
    educationLevel,
    extent,
    format,
    hasFormat,
    hasPart,
    hasVersion,
    identifier,
    instructionalMethod,
    isFormatOf,
    isPartOf,
    isReferencedBy,
    isReplacedBy,
    isRequiredBy,
    issued,
    isVersionOf,
    language,
    license,
    mediator,
    medium,
    modified,
    provenance,
    publisher,
    references,
    relation,
    replaces,
    requires,
    rights,
    rightsHolder,
    source,
    spatial,
    subject,
    tableOfContents,
    temporal,
    title,
    type,
    valid,
    Agent,
    AgentClass,
    BibliographicResource,
    FileFormat,
    Frequency,
    Jurisdiction,
    LicenseDocument,
    LinguisticSystem,
    Location,
    LocationPeriodOrJurisdiction,
    MediaType,
    MediaTypeOrExtent,
    MethodOfAccrual,
    MethodOfInstruction,
    PeriodOfTime,
    PhysicalMedium,
    PhysicalResource,
    Policy,
    ProvenanceStatement,
    RightsStatement,
    SizeOrDuration,
    Standard,
};
linkedOntology(_this, ns, 'dcterms', loadData, '../data/dcterms.json');
//# sourceMappingURL=dcterms.js.map